<template>
  <div class="pc-search">
    <el-form class="pc-search-main-formOne" :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title">
        <el-input v-model="keywordData.title_keyword" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="作品分类" placeholder="未选择" class="series">
        <el-select
          clearable
          filterable
          v-model="keywordData.classification_id"
          placeholder="未选择"
        >
          <el-option
            v-for="(item, key) in worksClassificationList"
            :label="item.chinese_name"
            :value="item.id"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="基地" placeholder="未选择" class="series">
        <el-select
          clearable
          filterable
          v-model="keywordData.base_id"
          placeholder="未选择"
        >
          <el-option
            v-for="(item, key) in baseDropDownList"
            :label="item.chinese_name"
            :value="item.id"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <br />
      <el-form-item label="标签" class="title">
        <keywordsinput
          :maxLen="18"
          v-model="keywordData.tags_keyword"
        ></keywordsinput>
      </el-form-item>

      <el-form-item label="作品竞赛分类" placeholder="未选择" class="series">
        <el-select
          clearable
          filterable
          v-model="keywordData.competition_id"
          placeholder="未选择"
        >
          <el-option
            v-for="(item, key) in exhibitionCompetitionList"
            :label="item.chinese_name"
            :value="item.id"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="展览" placeholder="未选择" class="series">
        <el-select
          clearable
          filterable
          v-model="keywordData.exhibition_id"
          placeholder="未选择"
        >
          <el-option
            v-for="(item, key) in exhibitionDropDownList"
            :label="item.chinese_name"
            :value="item.id"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <br />

      <el-form-item label="状态" placeholder="状态" class="status">
        <el-select v-model="keywordData.status" placeholder="有效" clearable>
          <el-option label="有效" value="1">有效</el-option>
          <el-option label="无效" value="0">无效</el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
import {
  exhibitionCompetitionDropDown_Api,
  worksClassification_Api,
  baseDropDown_Api,
  exhibitionDropDown_Api,
} from "@/apis/exhibition.api";
export default {
  data() {
    return {
      keywordData: {
        id: null,
        title_keyword: "",
        tags_keyword: [],
        status: null,
        exhibition_id: null,
        competition_id: null,
        classification_id: null,
        base_id: null,
      },
      exhibitionCompetitionList: [],
      worksClassificationList: [],
      baseDropDownList: [],
      exhibitionDropDownList: [],
    };
  },
  mounted() {
    this.getExhibitionCompetition();
    this.getWorksClassification();
    this.getBaseDropDown();
    this.getExhibitionDropDown();
  },
  methods: {
    getExhibitionCompetition() {
      exhibitionCompetitionDropDown_Api().then((res) => {
        this.exhibitionCompetitionList = res.data;
      });
    },
    getWorksClassification() {
      worksClassification_Api().then((res) => {
        this.worksClassificationList = res.data;
      });
    },
    getBaseDropDown() {
      baseDropDown_Api().then((res) => {
        this.baseDropDownList = res.data;
      });
    },
    getExhibitionDropDown() {
      exhibitionDropDown_Api().then((res) => {
        this.exhibitionDropDownList = res.data;
      });
    },
    search() {
      this.$emit("search", this.keywordData);
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .title {
    width: 400px;
  }
  .number {
    width: 300px;
    /deep/ .el-input-number {
      width: 190px;
    }
  }
  .keyword {
    width: 400px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .teacher {
    width: 300px;
    /deep/ .el-autocomplete {
      width: 190px;
    }
  }
  .series {
    width: 320px;
  }
  .status {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/component/WorksSearch.vue